// API configuration based on environment variables
const API_CONFIG = {
  baseURL:
    process.env.REACT_APP_BACKEND_URL || "https://sanifer-ventas.herokuapp.com",

  // Specific endpoints
  endpoints: {
    // Notifications
    sendNotification: "/sendNotification",

    // Email
    sendEmail: "/sendEmail",
  },
};

export default API_CONFIG;
